/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createIsPrime } from '../../factoriesAny.js';
export var isPrimeDependencies = {
  typedDependencies,
  createIsPrime
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesIsPrime.generated.js
// module id = 1386
// module chunks = 2